import { Star } from "lucide-react";

export const Stelle = ({ voto, size = "w-4 h-4", onChange, testidPrefix }) => (
  <div className="flex gap-0.5" aria-label={`${voto} stelle su 5`}>
    {[1, 2, 3, 4, 5].map((n) => {
      const icon = <Star className={`${size} ${n <= voto ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} className="p-1 hover:scale-110 transition-transform" data-testid={`${testidPrefix}-${n}`}>{icon}</button>
      ) : <span key={n}>{icon}</span>;
    })}
  </div>
);
